import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChartLabelsService {

  second = 0;
  labelsArray = [];

  constructor() { }


  generateChartLabels(totalSeconds: number, refreshInterval: number, maxLabels = 30) {
    const samplesPerSecond = 1000 / refreshInterval;
    const totalSamples = Math.round(totalSeconds * samplesPerSecond);

    // 1. Calculate desired step in seconds
    const rawStep = totalSeconds / maxLabels;

    // 2. Make it "nice"
    const niceStep = this.getNiceStep(rawStep);
    // 3. Convert step to samples (IMPORTANT)
    let stepInSamples = Math.round(niceStep * samplesPerSecond);

    // Prevent 0 or too small step
    if (stepInSamples < 1) stepInSamples = 1;

    const labels = [];

    for (let i = 0; i <= totalSamples; i++) {
      if (i % stepInSamples === 0) {
        const t = i / samplesPerSecond;
        labels.push(Number(t.toFixed(1)));
      } else {
        labels.push(null);
      }
    }
    return labels;
  }
  getNiceStep(step: number): number {
    const niceSteps = [
      1, 2, 5,
      10, 15, 30,
      60, 120, 300,
      600, 900, 1800, 3600
    ];

    for (let i = 0; i < niceSteps.length; i++) {
      if (step <= niceSteps[i]) {
        return niceSteps[i];
      }
    }

    return niceSteps[niceSteps.length - 1];
  }
  generateRawChartLabels(seconds) {
    const desiredLength = seconds * 83;
    const minValue = 0;
    const stepSize = (seconds - minValue) / (desiredLength - 1);
    const labels = [];
    for (let i = 0; i < desiredLength; i++) {
      const label = +(minValue + i * stepSize).toFixed(2);
      labels.push(label);
    }
    return labels;
  }
}
